import socket from './socketio.js'

type EmitResult<T> = {data?: T, errors?: string[], warnings?: string[]}

export const emit = async <T>(event: string, ...args: any[]): Promise<EmitResult<T>> => {
    return new Promise<EmitResult<T>>((resolve, reject) => {
        socket.emit(event, sessionStorage.token, ...args, (err?: string | Error, data?: T, errors?: string[], warnings?: string[]) => {
            if (err) {
                reject(typeof err === 'string' ? new Error(err) : err)
            } else {
                // callback signature is not consistent in backend so swap data and errors if data is an array of strings
                if (Array.isArray(data) && typeof data[0] === 'string') {
                    const tempData = data
                    data = errors as unknown as T
                    errors = tempData as unknown as string[]
                }

                resolve({data, errors, warnings})
            }
        })
    })
}
